import(/* webpackMode: "eager" */ "/var/www/service-geek/apps/web/src/app/global-error.tsx");
